import { createFileRoute, Link, Outlet, useLocation } from "@tanstack/react-router";
import { Flame, Activity, AlertTriangle, BarChart3, ShieldCheck } from "lucide-react";

export const Route = createFileRoute("/_authenticated/analytics")({
  component: AnalyticsLayout,
  head: () => ({ meta: [{ title: "Analytics — MissionReady" }] }),
});

const TABS: Array<{ to: "/analytics" | "/analytics/heatmaps" | "/analytics/activity" | "/analytics/incidents" | "/analytics/officers"; label: string; icon: any; exact?: boolean }> = [
  { to: "/analytics", label: "Overview", icon: BarChart3, exact: true },
  { to: "/analytics/heatmaps", label: "Heatmaps", icon: Flame },
  { to: "/analytics/activity", label: "Activity", icon: Activity },
  { to: "/analytics/incidents", label: "Incidents", icon: AlertTriangle },
  { to: "/analytics/officers", label: "Officers", icon: ShieldCheck },
];

function AnalyticsLayout() {
  const loc = useLocation();
  return (
    <div className="px-4 py-6 md:px-8 md:py-8">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="font-display text-2xl font-bold md:text-3xl">Analytics</h1>
          <p className="text-sm text-muted-foreground">Operational density, incident hotspots and patrol coverage.</p>
        </div>
      </div>

      <nav className="mt-5 flex gap-1 overflow-x-auto border-b border-border">
        {TABS.map((t) => {
          const active = t.exact ? loc.pathname === t.to : loc.pathname.startsWith(t.to);
          const Icon = t.icon;
          return (
            <Link
              key={t.to}
              to={t.to}
              className={`flex items-center gap-2 border-b-2 px-3 py-2 text-sm transition-colors ${
                active ? "border-primary text-primary" : "border-transparent text-muted-foreground hover:text-foreground"
              }`}
            >
              <Icon className="h-4 w-4" />
              {t.label}
            </Link>
          );
        })}
      </nav>

      <div className="mt-6">
        <Outlet />
      </div>
    </div>
  );
}
